import React from 'react';
import styles from './AlertBanner.module.css';

const DEFAULT_ICONS = {
  info: 'ℹ️',
  success: '✅',
  warning: '⚠️',
  error: '⚠️',
};

/**
 * Token tabanlı bilgi/başarı/uyarı/hata kutusu. Inline veya sabit (toast) kullanılabilir.
 * severity: info | success | warning | error
 */
const AlertBanner = ({
  severity = 'info',
  message,
  children,
  title,
  actionLabel,
  onAction,
  onDismiss,
  live = 'polite',
  fixed = false,
  icon,
  className = '',
  ...rest
}) => {
  const classes = [styles.banner, styles[severity] || styles.info, fixed ? styles.fixed : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={classes}
      role="alert"
      aria-live={severity === 'error' ? 'assertive' : live}
      {...rest}
    >
      <span className={styles.icon} aria-hidden="true">
        {icon ?? DEFAULT_ICONS[severity]}
      </span>
      <div className={styles.body}>
        {title && <div className={styles.title}>{title}</div>}
        <div className={styles.message}>{message ?? children}</div>
      </div>
      {actionLabel && onAction && (
        <button type="button" className={styles.action} onClick={onAction}>
          {actionLabel}
        </button>
      )}
      {onDismiss && (
        <button type="button" className={styles.dismiss} onClick={onDismiss} aria-label="Kapat">
          ✕
        </button>
      )}
    </div>
  );
};

export default AlertBanner;
